module.exports = __webpack_public_path__ + "static/media/app-store-it.dd2a3501.svg";